"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyEditPopover = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyButton_1 = __importDefault(require("../SskyButton"));

const SskyPopover_1 = __importDefault(require("../SskyPopover"));

const SskyTextField_1 = __importDefault(require("../SskyTextField"));

const StyledButtonsContainer = (0, material_1.styled)("div")({
  marginTop: 24
});
const StyledSskyButton = (0, material_1.styled)(SskyButton_1.default)({
  float: "right",
  minWidth: 90
});

const SskyEditPopover = props => {
  return react_1.default.createElement(SskyPopover_1.default, {
    id: props.id,
    className: props.className,
    open: props.open,
    anchor: props.anchor,
    paperProps: props.paperProps,
    onClose: props.onClose,
    "data-testid": props.dataTestId ? `${props.dataTestId}-popover` : `testId-${props.id}-popover`
  }, react_1.default.createElement(SskyTextField_1.default, {
    maxLength: props.maxLength,
    label: props.label || "",
    value: props.value,
    defaultValue: props.defaultValue,
    fullWidth: true,
    multiline: true,
    error: !props.isValid,
    helperText: !props.isValid || props.showHelperText ? props.helperText : " ",
    onChange: props.handleChange,
    autoFocus: props.autoFocus,
    "data-testid": props.dataTestId ? `${props.dataTestId}-textField` : `testId-${props.id}-textField`
  }), react_1.default.createElement(StyledButtonsContainer, null, react_1.default.createElement(StyledSskyButton, {
    label: props.positiveButtonText,
    onClick: props.onPositiveClick,
    sx: {
      margin: 0
    },
    autoFocus: true,
    "data-testid": props.dataTestId ? `${props.dataTestId}-positiveButton` : `testId-${props.id}-positiveButton`
  }), react_1.default.createElement(StyledSskyButton, {
    label: props.negativeButtonText,
    color: "inherit",
    variant: "outlined",
    onClick: props.onNegativeClick,
    sx: {
      margin: "0 10px"
    },
    "data-testid": props.dataTestId ? `${props.dataTestId}-negativeButton` : `testId-${props.id}-negativeButton`
  })));
};

exports.SskyEditPopover = SskyEditPopover;
SskyEditPopover.defaultProps = {
  isValid: true,
  negativeButtonText: "Cancel",
  positiveButtonText: "Save"
};
exports.default = react_1.default.memo(SskyEditPopover);